import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import successToast from '../../components/toasts/successToast';
import { useDispatch } from 'react-redux';
import { usersDropDown } from '../../redux/actions/documentAction';
import errorToast from '../../components/toasts/errorToast';
import { sendPostEditingAction } from '../../redux/actions/translationAction';
import { Spinner } from 'react-bootstrap';


const AssignUser = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const selectedJobs = location.state?.jobs || [];

    useEffect(() => {
        dispatch(usersDropDown({}, (data) => { setUsers(data?.data?.data) }, onError))
    }, []);

    const onError = (data) => {
        setLoading(false);
        errorToast(data?.data?.message)
    }
    console.log(selectedJobs, 'selectedJobs');

    const initialValues = {
        user_id: '',
        task: '',
        comments: '',
        job_ids: selectedJobs,
    };

    const validationSchema = Yup.object().shape({
        user_id: Yup.string().required('Required'),
        task: Yup.string().required('Required'),
        comments: Yup.string().required('Required'),
    });


    const onSubmit = (values) => {
        setLoading(true);
        dispatch(sendPostEditingAction(values, onAssignSuccess, onError))
    };

    const onAssignSuccess = (data) => {
        setLoading(false);
        successToast(data.data.message);
        navigate(-1);
    }

    const tasks = [
        { id: 1, name: 'Post Editing' },
        { id: 2, name: 'Review' },
    ];

    return (
        <div className="d-flex vh-100">
            <div className="w-100 d-flex flex-column">
                <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">Assign to User</h2>
                </div>
                <div className="flex-grow-1 pt-3">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values, setFieldValue, isValid, dirty }) => (
                            <Form className=" h-100 justify-content-between">
                                <div>
                                    <div className="text-start gap-2 mb-2 text-nowrap mx-4">
                                        <label htmlFor="user_id" className="py-1">User</label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                name="user_id"
                                                as="select"
                                                className="input-field"
                                                id="user_id"
                                                style={{ width: '20rem' }}
                                            >
                                                <option value="">Select a User</option>
                                                {users.map((user) => (
                                                    <option key={user?.id} value={user?.id}>
                                                        {user?.email}
                                                    </option>
                                                ))}
                                            </Field>
                                        </div>
                                        <ErrorMessage name="user_id" component="div" className="text-danger mt-1 fs_12" />
                                    </div>

                                    <div className="text-start gap-2 mb-2 text-nowrap mx-4">
                                        <label htmlFor="task" className="py-1">Task</label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                name="task"
                                                as="select"
                                                className="input-field"
                                                id="task"
                                                style={{ width: '20rem' }}
                                            >
                                                <option value="">Select a Task</option>
                                                {tasks.map((task) => (
                                                    <option key={task.id} value={task.name}>
                                                        {task.name}
                                                    </option>
                                                ))}
                                            </Field>
                                        </div>
                                        <ErrorMessage name="task" component="div" className="text-danger mt-1 fs_12" />
                                    </div>
                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                        <label htmlFor='comments' className="py-1">Comments</label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                name='comments'
                                                as="textarea"
                                                className="input-field"
                                                id='comments'
                                                style={{ width: '20rem' }}
                                            />
                                        </div>
                                        <ErrorMessage name='comments' component="div" className="text-danger mt-1 fs_12" />
                                    </div>



                                </div>

                                <div className="d-flex gap-5 mt-4 mx-4 my-3">
                                    <button type="submit" className="btn btn-primary cursor_pointer"
                                        style={{ minWidth: '6rem' }} disabled={!(isValid && dirty) || loading} >
                                        <div className='fs_12 d-flex gap-2 justify-content-center'>
                                            {loading ? <Spinner size="sm" className="mt-1" /> : ""}
                                            <label className="fs_16">{!loading ? 'Send' : 'Sending...'}</label>
                                        </div>
                                    </button>
                                    <button type="button" className="btn btn-secondary" style={{ width: '5rem' }} onClick={() => navigate(-1)}>Cancel</button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
};

export default AssignUser;




